<h2 mat-dialog-title>Delete Maintenance Window</h2>
<mat-dialog-content class="mat-typography">
    <p>Are you sure that you want to delete this maintenance window?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button (click)="onConfirm()" cdkFocusInitial>Yes</button>
</mat-dialog-actions>
